import { render, staticRenderFns } from "./Startpage.vue?vue&type=template&id=0f3c06ea&"
import script from "./Startpage.vue?vue&type=script&lang=js&"
export * from "./Startpage.vue?vue&type=script&lang=js&"
import style0 from "./Startpage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Startpage.vue"
export default component.exports